module.exports = __webpack_public_path__ + "img/INSIGHTS (3).4369447b.png";